import { NgModule } from '@angular/core';
import { AuthService, CmsConfig, ConfigModule } from '@spartacus/core';
import { CustomAuthService } from '../../../../../../services/auth/custom-auth.service';
import { CustomLoginComponent } from './custom-login.component';

@NgModule({
  exports: [CustomLoginComponent],
  imports: [
    CustomLoginComponent,
    ConfigModule.withConfig({
      cmsComponents: {
        LoginComponent: {
          component: CustomLoginComponent
        }
      }
    } as CmsConfig)
  ],
  providers: [
    {
      provide: AuthService,
      useClass: CustomAuthService
    }
  ]
})
export class CustomLoginModule {}
